import React from 'react';
import Navigation from './Navigation';
import logoImage from '../assets/enew-studio-logo.svg';
import layout from '../styles/layout.module.css';
import styles from './Header.module.css';

interface HeaderProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const Header: React.FC<HeaderProps> = ({ activeSection, onSectionChange }) => {
  return (
    <>
      <a href="#main-content" className={styles.skipLink}>
        メインコンテンツにスキップ
      </a>

      <header className={styles.siteHeader}>
        <div className={`${layout.wrap} ${styles.inner}`}>
          <a
            href="/"
            className={styles.logoLink}
            aria-label="株式会社eNEW Studio ホーム"
          >
            <img
              src={logoImage}
              alt="eNEW Studio"
              width="137"
              height="36"
              className={styles.logoImage}
            />
          </a>
          <Navigation
            activeSection={activeSection}
            onSectionChange={onSectionChange}
          />
        </div>
      </header>
    </>
  );
};

export default Header;
